<div class="addGrpDialogue">
  <!--The Heading sections (Heading + Serach )-->
  <mat-toolbar class="header heading-background">
    <!--<div class="row heading-background mt-5">-->
    <div class="col-lg-6">
      <h5>Add {{ data.title }}</h5>
    </div>
    <div class="col-lg-6 search-container">
      <div (change)="updateRolesResults()" (keyup)="updateRolesResults()">
        <input class="form-control" type="text" placeholder="Search" [(ngModel)]="searchString" />
      </div>
    </div>
  </mat-toolbar>

  <!--The Table-->
  @if (!IsDirIndirComponent) {
    <div class="custom_small_panelbody_fix">
      <mat-selection-list>
        @if (showSelectAllCheckbox) {
          <mat-list-option
            [value]="'selectall'"
            style="font-weight: 600; background: #1b1b1b"
            (click)="toggleSelectAll($event)"
            [selected]="allSelected"
            checkboxPosition="before"
            >
            Select All
          </mat-list-option>
        }
        @for (item of filteredSearchResults; track item.id) {
          <mat-list-option
            [value]="item.id"
            [selected]="selectedIds.has(item.id)"
            (click)="toggleItemSelection(item.id)"
            checkboxPosition="before"
            >
            {{ item.persona }}
            @if (hasAdditionalCosts(item.persona) === 1) {
              <span style="color: greenyellow !important">$$</span>
            }
            @if (hasAdditionalCosts(item.persona) === 0) {
              <span style="color: greenyellow !important">$</span>
            }
          </mat-list-option>
        }
      </mat-selection-list>
    </div>
  }

  @if (IsDirIndirComponent) {
    <div class="custom_small_panelbody_fix">
      @if (userPrimaryRole) {
        <h5 style="padding: 0 16px">
          User already assigned to {{ userPrimaryRole.persona }}. Role must be removed to assign another Primary Role
          <mat-icon
            class="adgroup-custom-tooltip"
            matTooltipClass="adgroup-custom-tooltip"
            matTooltip="Primary Roles: {{ primaryRoles }}"
            >info</mat-icon
            >
          </h5>
        }
        <mat-selection-list [multiple]="false" hideSingleSelectionIndicator="true">
          @for (item of filteredSearchResults; track item.id) {
            <mat-list-option
              [value]="item.id"
              [selected]="selectedIds.has(item.id)"
              (click)="toggleSingleItemSelection(item.id)"
              checkboxPosition="before"
              [disabled]="userPrimaryRole && item.isPrimaryRole"
              >
              {{ item.persona }}
            </mat-list-option>
          }
        </mat-selection-list>
      </div>
    }

    <div class="panel-body">
      <button type="button" (click)="backButtonHandler($event)" mat-raised-button class="btn button-fix button-color-fix-red">
        <mat-icon class="icon-color-fix">arrow_back_ios</mat-icon>
        Back
      </button>
      <button
        mat-raised-button
        type="submit"
        (click)="addButtonHandler()"
        [disabled]="selectedIds.size === 0"
        class="btn button-fix button-color-fix-orange pull-right"
        >
        Save
        <mat-icon class="icon-color-fix">save</mat-icon>
      </button>
    </div>
  </div>
